module.exports = __webpack_public_path__ + "img/travel2.43644972.png";